import React, { Component } from 'react';
import styled from 'styled-components';

const months = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
];

// warning: major hack ahead
export default class Schedule extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cellWidth: 0,
      campaignCellWidth: 0,
      campaignHeaderWidth: 0,
      cellHeights: {},
    };
  }

  componentDidMount() {
    /* eslint-disable-next-line */
    const campaignCell = document.getElementsByClassName('table-cell-campaign')[0];
    const campaignCellWidth = campaignCell && campaignCell.offsetWidth;

    /* eslint-disable-next-line */
    const campaignHeader = document.getElementsByClassName('campaign-header')[0];
    const campaignHeaderWidth = campaignHeader && campaignHeader.offsetWidth - 62;

    setTimeout(() => {
      /* eslint-disable-next-line */
      const cell = document.getElementsByClassName('table-cell')[0];
      const cellWidth = cell && cell.offsetWidth;

      if (cellWidth) {
        this.setState({
          cellWidth,
          campaignCellWidth,
          campaignHeaderWidth,
        }, () => {
          /* eslint-disable-next-line */
          const cells = document.getElementsByClassName('table-cell');

          const cellHeights = {};
          for (let i = 0; i < cells.length; i += 1) {
            const dataId = cells[i].getAttribute('data-id');
            if (dataId) cellHeights[dataId] = cells[i].offsetHeight;
          }
          this.setState({ cellHeights });
        });
      }
    }, 100);
  }

  render() {
    /* eslint-disable-next-line */
    const { campaigns, small } = this.props;
    const { cellWidth, campaignCellWidth, campaignHeaderWidth } = this.state;

    const currentDate = new Date();
    const validCampaigns = campaigns.filter(campaign => !campaign.isDefault && campaign.states && campaign.status === 'approved' && new Date(campaign.endDate) > currentDate);

    const minCampaigns = small ? 6 : 7;
    const campaignsNum = validCampaigns.length;
    /* eslint-disable-next-line */
    let isMin = false;
    if (campaignsNum < minCampaigns) {
      isMin = true;
      const appendedCampaigns = minCampaigns - campaignsNum;
      for (let j = 0; j < appendedCampaigns; j += 1) {
        validCampaigns.push({ campaignName: '', states: [] });
      }
    }

    // const minWeeks = small ? 5 : 6;
    const minWeeks = 6;
    const weeks = [];
    let nextDate = new Date();
    for (let i = 0; i < minWeeks; i += 1) {
      weeks.push(nextDate);
      nextDate = new Date(
        nextDate.getTime() + (7 * 24 * 60 * 60 * 1000)
      );
    }

    // const totalHeight = small ? 370 : 440;
    // const rowHeight = totalHeight / (minCampaigns + 1);

    const totalAvailableTime = weeks[weeks.length - 1] - weeks[0];

    // const divMarginTop = rowHeight * -0.80;

    return (
      <ScheduleContainer small={small} style={{ overflowX: 'hidden', overflowY: 'scroll' }}>
        <Table>
          <thead>
            {/* <Th style={{ textAlign: 'left', paddingLeft: 30, width: campaignWidth }}>CAMPAIGN NAME</Th> */}
            <Th style={{ textAlign: 'left', paddingLeft: 30, width: campaignHeaderWidth }} className="campaign-header">CAMPAIGN NAME</Th>
            {
              weeks.map((week, i) => (
                /* eslint-disable-next-line */
                <Th style={i === weeks.length - 1 ? { borderRight: 'none' } : {}}>{week.getDate()} {months[week.getMonth()]}</Th>
              ))
            }
          </thead>
          {
            /* eslint-disable-next-line */
            validCampaigns.map((campaign) => {
              // const start = new Date(campaign.startDate) - currentDate;

              // let totalWidth = 0;
              // let calculatedWidth = 0;

              // if (start > 0) {
              //   totalWidth = cellWidth * 6;
              //   calculatedWidth = start * totalWidth / totalAvailableTime / 2;
              // }

              // 1) determine margin based on startDate
              const totalWidth = cellWidth * 6;
              const start = new Date(campaign.startDate) - currentDate;
              let startMargin = start * totalWidth / totalAvailableTime;
              let startBefore = false;
              if (startMargin < 0) {
                startBefore = true;
                startMargin = 0;
              }
              startMargin += campaignCellWidth;

              // 2) determine width based on endDate
              const duration = new Date(campaign.endDate) - new Date(campaign.startDate);
              let durationWidth = duration * totalWidth / totalAvailableTime;
              let endAfter = false;
              if (durationWidth > totalWidth) {
                endAfter = true;
                durationWidth = totalWidth;
              }

              const divStyle = { marginLeft: startMargin, width: durationWidth };
              if (startBefore) {
                divStyle.topLeft = 0;
                divStyle.bottomLeft = 0;
              }
              if (endAfter) {
                divStyle.topRight = 0;
                divStyle.bottomRight = 0;
              }

              const Bar = () => {
                /* eslint-disable-next-line */
                const cell = document.getElementsByClassName(campaign.id)[0];
                /* eslint-disable-next-line */
                const cellHeight = this.state.cellHeights[campaign.id] || 60;

                return (
                  <Div style={{ marginLeft: startMargin, width: durationWidth, marginTop: cellHeight / 2 - 15 }} />
                );
                  // <Div style={{ marginLeft: startMargin, width: durationWidth, marginTop: cellHeight / -2 + -15 }} />
              };

              return (
                <React.Fragment>
                  <Bar />
                  <tr style={{ height: 60 }}>
                    <Td className={`table-cell-campaign ${campaign.id}`} style={{ width: campaignHeaderWidth, overflow: 'hidden' }}>
                      <H2 style={{ width: campaignHeaderWidth - 20, wordBreak: 'break-all', overflow: 'hidden' }}>{campaign.campaignName}</H2>
                      <P>{campaign.states && campaign.states.join(', ')}</P>
                    </Td>
                    <Td className="table-cell" data-id={campaign.id} />
                    <Td />
                    <Td />
                    <Td />
                    <Td />
                    <Td style={{ borderRight: 'none' }} />
                  </tr>
                </React.Fragment>
              );
            })
          }
        </Table>
      </ScheduleContainer>
    );
  }
}

const Table = styled.table`
  // margin: 12% auto;
  width: 100%;
  text-align: left;
  font-family: 'Karla', sans-serif;
  position: relative;
  border-spacing: 0px;
  // border: 2px solid #e2e5ef;
`;

const Th = styled.th`
  font-size: 18px;
  text-align: center;
  padding: 20px 0;
  color: #384076;
  letter-spacing: 1px;
  border-bottom: 2px solid #e2e5ef;
  border-right: 2px solid #e2e5ef;
  position: sticky;
  top: 0px;
  background-color: white;
  z-index: 999;
`;

const Td = styled.td`
  padding: 10px 30px;
  border-bottom: 2px solid #e2e5ef;
  border-right: 2px solid #e2e5ef;
`;

const H2 = styled.h2`
  color: #384076;
  font-size: 16px;
  margin-top: 0px;
  margin-bottom: 0px;
  letter-spacing: 0.5px;
`;

const P = styled.div`
  color: #9FABB4;
`;

const Div = styled.div`
  position: absolute;
  height: 30px;
  background-color: #5d81ec;
  border-radius: 5px;
  // margin-top: -50px;
`;

const ScheduleContainer = styled.div`
  overflow: scroll;
  // margin-top: 20px;
  height: ${props => props.small ? 370 : 440}px;
  // padding: 20px;
  border: ${props => props.small ? 2 : 2.5}px solid #E2E5EF;
  border-radius: 3px;
`;



// WEBPACK FOOTER //
// ./client/Dashboard/components/Schedule.js